import { Injectable } from '@angular/core';

import { NOTIFICATION_TYPE } from '../metadata/interfaces/GuestChecking';
import { Router } from '@angular/router';
import { ApiConstant, UtilService } from '../constants/app.constant';
declare var $: any;


@Injectable({
  providedIn: 'root'
})
export class IANotificationService {

  public static _IsConnected: boolean = false; 
  private static _PingInterval = 10000;  // 10 seconds
  private static _AliveTimeout = 5000;   // 5 seconds
  private static _IsLinkAliveReceived = true;
  private static _MaxReconnectAttempts = 50;
  private static _ReconnectAttempts = 0;
  private static _ReconnectDelay = 5000;  // 5 seconds starting delay
  private static _MaxReconnectDelay = 3600000;  // 1 minute maximum delay
  private static _Interval: any;  // 10 seconds
  private static _router: Router;

  constructor(private router: Router) { 
    IANotificationService._router = router;
  }

  public static _PauseSessionForAuthenticationCallBack: (param: any) => any;
  public static _DoorEventCallBack: (param: any) => any;
  public static _IAResultCallBack: (param: any) => any;
  public static _DoorEventMonitoringCallBack: (param: any) => any;
  public static _DoorAliveCallBack: (param: any) => any;
  public static _Hub : any;
  public static  _ConHubProxy  : any; 
  public static _ApiType = 2; /* browser */
  public static _SourceVersion = "2.1"; /* integra */

  public static HandleNotification()
  {   
    var TmpUser = sessionStorage.getItem("userInfo");
    if(TmpUser == undefined || TmpUser == null)
    return;

    var user = JSON.parse(atob(TmpUser)); 

    if(!user)
    return;
  
    var Sys =  UtilService.GetSystemCode(false);
    let Paramter = {'AccountID' : Sys, 'SystemCode' : Sys, 'SourceVersion' : IANotificationService._SourceVersion, 'ApiType' : IANotificationService._ApiType, 'EnterPriseName' : user.Email};
    this._Hub = $.hubConnection(ApiConstant.baseUrlNotify, Paramter); 
    this._Hub.qs = Paramter; 
    this._ConHubProxy = this._Hub.createHubProxy('BrowserClientHub');
    this._ConHubProxy.on('HandleEvents', this.HandleEvents);
    this._ConHubProxy.on('PingAcknowledged', this.PingAcknowledgedEvent);
    this._ConHubProxy.on('HandleConcurrentUser', this.HandleConcurrentUser);

    this._Hub.start({ withCredentials: false }).done( () => {      
      this._ConHubProxy.invoke('SubscribToEventsv2', {_Source: IANotificationService._SourceVersion, _Systemcode: Sys, _ApiType: IANotificationService._ApiType, _EnterpriseName:Sys, _Email: user.Email }); 
      
      console.log('connected and subscribed...');
      
      this.SetSubscriptionTime(); 
    });
  
    this.HandleConnectionState();

  }

  public static HandleNotificationv1()
  {   

    /* call this function only when the login has been done */
    console.log("HandleNotification called ..... ");
    // if(IANotificationService._IsConnected)
    //  {
    //   console.log("HandleNotification connected...");
    //   return;
    //  } 
    var user = JSON.parse(atob(sessionStorage.getItem("userInfo"))); 

    //alert("HandleNotifacation");
    //var Sys = '11111111'; //UtilService.GetSystemCode(true);
    var Sys =  UtilService.GetSystemCode(false);
    let Paramter = {'AccountID' : Sys, 'SystemCode' : Sys, 'SourceVersion' : IANotificationService._SourceVersion, 'ApiType' : IANotificationService._ApiType, 'EnterPriseName' : Sys};
    var Hub = $.hubConnection(ApiConstant.baseUrlNotify, Paramter);
    //var Hub = $.hubConnection('https://integra-cloud-api.myamadeo.net', Paramter);
    Hub.qs = Paramter; 
    //Hub.logging = true;     
  
    var ConHubProxy = Hub.createHubProxy('BrowserClientHub');
    ConHubProxy.on('HandleEvents', this.HandleEvents);

    Hub.start({ withCredentials: false }).done(function ()
    {     
      //ConHubProxy.invoke('SubscribToEvents', Sys, 'TWM5MDIxMCE='); 
      ConHubProxy.invoke('SubscribToEventsv2', {_Source: IANotificationService._SourceVersion, _Systemcode: Sys, _ApiType: IANotificationService._ApiType, _EnterpriseName:Sys, _Email: user.Email }); 
      
      IANotificationService._IsConnected = true;

    });
 

    Hub.disconnected(function() {
      alert("Disconnected...");

      // You can implement a reconnection logic here if needed
      });

 

   }

   public static DisconnectV1() {

     /* call this function only when the login has been done */
     console.log("Disconnect called ..... "); 
     var user = JSON.parse(atob(sessionStorage.getItem("userInfo")));  
     var Sys =  UtilService.GetSystemCode(false); 
     this._ConHubProxy.invoke('SubscribToEventsv2', {_Source: IANotificationService._SourceVersion, _Systemcode: Sys, _ApiType: IANotificationService._ApiType, _EnterpriseName:Sys, _Email: user.Email }); 
     return;

     let Paramter = {'AccountID' : Sys, 'SystemCode' : Sys, 'SourceVersion' : IANotificationService._SourceVersion, 'ApiType' : IANotificationService._ApiType, 'EnterPriseName' : Sys};
     var Hub = $.hubConnection(ApiConstant.baseUrlNotify, Paramter); 
     Hub.qs = Paramter; 
      
     var ConHubProxy = Hub.createHubProxy('BrowserClientHub');
     ConHubProxy.on('HandleEvents', this.HandleEvents);
 
     Hub.start({ withCredentials: false }).done(function ()
     {      
       ConHubProxy.invoke('UnSubscribToEventsv2', {_Source: IANotificationService._SourceVersion, _Systemcode: Sys, _ApiType: IANotificationService._ApiType, _EnterpriseName:Sys, _Email: user.Email }); 
       IANotificationService._IsConnected = false; 
     });

   }

   // Function to handle exponential backoff during reconnection attempts
 private static ReconnectWithBackoff() { 
  var TmpUser = sessionStorage.getItem("userInfo");
  if(TmpUser == undefined || TmpUser == null)
  return;

  var user = JSON.parse(atob(TmpUser)); 

  if(!user)
    return;

  var Sys =  UtilService.GetSystemCode(false);

  if (true /*this._ReconnectAttempts < this._MaxReconnectAttempts*/) {
    setTimeout(() => {
      var user = JSON.parse(atob(sessionStorage.getItem("userInfo")));  
      var Sys =  UtilService.GetSystemCode(false);
      let Paramter = {'AccountID' : Sys, 'SystemCode' : Sys, 'SourceVersion' : IANotificationService._SourceVersion, 'ApiType' : IANotificationService._ApiType, 'EnterPriseName' : user.Email};
      // this._ConHubProxy.on('HandleEvents', this.HandleEvents);
      // this._ConHubProxy.on('PingAcknowledged', this.PingAcknowledgedEvent);
      this._Hub.start({ withCredentials: false })
            .done(() => {
              this._ConHubProxy.invoke('SubscribToEventsv2', {_Source: IANotificationService._SourceVersion, _Systemcode: Sys, _ApiType: IANotificationService._ApiType, _EnterpriseName:Sys, _Email: user.Email }); 
              this._ConHubProxy.invoke('IsLinkAlive', {});
              this._ReconnectAttempts = 0;
              this._ReconnectDelay = 0;
              this.SetSubscriptionTime();
              this.StartHeartbeat();
                console.log('Reconnected');
            })
            .fail(() => {
              this._ReconnectAttempts++;
                console.log('Reconnect attempt failed. Trying again in', this._ReconnectDelay, 'ms');
                this._ReconnectDelay = Math.min(this._ReconnectDelay * 2, this._MaxReconnectDelay);  // Double the delay, but don't exceed max
                this.ReconnectWithBackoff();
            });
    }, this._ReconnectDelay);
  } 
  else {
    var tmp = 'Max reconnect attempts reached. Please check the server or network.';
    //console.log(tmp);
    //alert(tmp); 
    window.location.href =  './auth/signin';
    // call a callback here to display a warning to the customer, and he can choose to reconnect or to logout 
  }           
}

private static StartHeartbeat() {
 
  this._Interval = setInterval(() => {
    //if (this._IsLinkAliveReceived) {
      this._IsLinkAliveReceived = false;

      if(this._Hub.state !== $.signalR.connectionState.connected || this.ForcePing())
      {
        this._ConHubProxy.invoke('IsLinkAlive', {})
            .done(() => {
                setTimeout(() => {
                    if (!this._IsLinkAliveReceived) {
                        console.log('IsLinkAlive not received. Reconnecting...');
                        //this._Hub.stop();
                        this.Disconnect();
                        this.ReconnectWithBackoff();
                    }
                }, this._AliveTimeout);
            })
            .fail((error) => {
              this.Disconnect();
              this.ReconnectWithBackoff();
                console.log('Error invoking Pong:', error);
            });
      }
      else
      this._IsLinkAliveReceived = true;

    //}
}, this._PingInterval); 
}


 

private static ForcePing(): boolean {
  const currentTime = new Date();
  const lastUpdatedTimeStr = localStorage.getItem('lastUpdatedTime');
  const lastUpdatedTime = lastUpdatedTimeStr ? new Date(lastUpdatedTimeStr) : currentTime;

  const diffInMinutes = Math.abs(currentTime.getTime() - lastUpdatedTime.getTime()) / (1000 * 60);

  if(diffInMinutes >= 5)
  {
    localStorage.setItem('lastUpdatedTime', currentTime.toISOString());
    return true;
  }

  return false;
}
 

private static StopHeartbeat() {
  if (this._Interval) {
      clearInterval(this._Interval);
      this._Interval = null;
  }
}

public static Disconnect() {
  this.StopHeartbeat();
  this._Hub.stop();
  console.log('Disconnected from the SignalR hub.');
}

private static HandleConnectionState() {

  setTimeout(() => {
    this.StartHeartbeat();
  }, 3000);
 
  return;
// Monitor SignalR connection state
this._Hub.stateChanged((change) => {
  if (change.newState === $.signalR.connectionState.connected) {
    this.StartHeartbeat();
  } else if (change.newState === $.signalR.connectionState.disconnected) {
     {
      this.StopHeartbeat();
      this.ReconnectWithBackoff();
     } 
  }
}); 
 
}

public static PingAcknowledgedEvent(Event : any) : void {   
  this._IsLinkAliveReceived = true;
  //alert('IsLinkAlive acknowledged by server.' + Event);
   console.log('IsLinkAlive acknowledged by server.');
}

public static HandleConcurrentUser(Event : any) : void {   
  console.log('HandleConcurrentUser received by server.');
  IANotificationService.EnsureOnlyOneUserLoggedIn();
}

 
public static HandleEvents(Event : any) : void {  
    var Data = JSON.parse(Event.Data);
 
    // alert(Data._NotificationType); 
    if(Data._NotificationType === NOTIFICATION_TYPE.IARESULTS)
    {
       //console.log("Inotificator => ", JSON.stringify(Data._ContentData)); 
       if(IANotificationService._IAResultCallBack !== undefined)
        IANotificationService._IAResultCallBack(JSON.parse(JSON.stringify(Data._ContentData)));
      
    }
    else if(Data._NotificationType === NOTIFICATION_TYPE.DOOR_EVENTS)
    {
      if(IANotificationService._DoorEventCallBack !== undefined)
        IANotificationService._DoorEventCallBack(JSON.parse(JSON.stringify(Data._ContentData)));

        if(IANotificationService._DoorEventMonitoringCallBack !== undefined)
          IANotificationService._DoorEventMonitoringCallBack(JSON.parse(JSON.stringify(Data._ContentData)));

        // else if(Data._NotificationType === NOTIFICATION_TYPE.CACHE_DATA)
        // this._PauseSessionForAuthenticationCallBack(Data);
    }
    else if(Data._NotificationType === NOTIFICATION_TYPE.CACHE_DATA)
    {
        
    }
    else if(Data._NotificationType === NOTIFICATION_TYPE.ALIVE_DATA)
    {
      if(IANotificationService._DoorAliveCallBack !== undefined)
          IANotificationService._DoorAliveCallBack(JSON.parse(JSON.stringify(Data._ContentData)));
    }

  }


  public static SetCallBack(PauseSessionForAuthenticationCallBack: (param: any) => any,  DoorEventsCallBack: (param: any) => any){

    IANotificationService._DoorEventCallBack = DoorEventsCallBack;
   // this._PauseSessionForAuthenticationCallBack = PauseSessionForAuthenticationCallBack;

  }


  public static SetIACallBack(IACallBack: (param: any) => any)
  {
    IANotificationService._IAResultCallBack = IACallBack;
 
    //alert("set..." + JSON.stringify(this._IAResultCallBack));
    //this._IAResultCallBack("s");
  }
 
  public static SetIAMonitoringCallBack(IAMonitoringCallBack: (param: any) => any, IAAliveCallBack: (param: any) => any)
  {
    IANotificationService._DoorEventMonitoringCallBack = IAMonitoringCallBack;
    IANotificationService._DoorAliveCallBack = IAAliveCallBack; 
  }


  private static SetSubscriptionTime()
  {
    const currentUserTime = new Date();
    const currentUserTimeStr = currentUserTime.toISOString(); // Convert to string for storage
  
    sessionStorage.setItem('ConcurrentUser', currentUserTimeStr);
  }
  
  private static EnsureOnlyOneUserLoggedIn()
  { 
    const currentUserTimeStr = sessionStorage.getItem('ConcurrentUser');
    //console.log("currentUserTimeStr -> ", currentUserTimeStr);
  
    if (currentUserTimeStr) {
      const currentUserTime = new Date(currentUserTimeStr);
  
      // Calculate the time difference in milliseconds
      const timeDifference = new Date().getTime() - currentUserTime.getTime();
      //console.log("timeDifference -> ", timeDifference);
  
      // Check if the time difference is greater than 1 minute (60,000 milliseconds)
      if (timeDifference > 15000) {
  
        this.Disconnect();
        // Redirect to ./index
        sessionStorage.clear();
        sessionStorage.setItem('LogOutReason', "1");
        window.location.href =  './auth/signin';

        
      } 
    }
  }


}
